import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FilterBasic from '../../../basicElement/FilterBasic';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import dictCache from '../../../../common/dictCache';

const accountDistributes =[
    { accountDistribute: "forFuture",accountDistributeShow:'信用期内' },
    { accountDistribute: "less31",accountDistributeShow:'31天以内（逾期）' },
    { accountDistribute: "day31To60",accountDistributeShow:'31~60天（逾期）' },
    { accountDistribute: "day61To90",accountDistributeShow:'61~90天（逾期）' },
    { accountDistribute: "day91To120",accountDistributeShow:'91~120天（逾期）' },
    { accountDistribute: "day121To150",accountDistributeShow:'121~150天（逾期）' },
    { accountDistribute: "day151To180",accountDistributeShow:'151~180天（逾期）' },
    { accountDistribute: "day181To3650",accountDistributeShow:'181~365天（逾期）' },
    { accountDistribute: "day366To730",accountDistributeShow:'366~730天（逾期）' },
    { accountDistribute: "day731To1095",accountDistributeShow:'731~1095天（逾期）' },
    { accountDistribute: "great1095",accountDistributeShow:'1095天以上（逾期）' },
    { accountDistribute: "sumGreat120",accountDistributeShow:'120天以上合计' },
    { accountDistribute: "sumGreat365",accountDistributeShow:'365天以上合计' },
]
class FundsFilter extends Component {
    static contextTypes = {
        configure: PropTypes.object
    };

    state = {
        areaOptions: [],
        diseaseOptions: [],
        businessList: [],
    }

    componentDidMount() {
        this.loadAreaList();
        this.queryWithLevelByParams();
        // 点击返回，级联选择的’疾病‘选择项丢失 bug 31562
        const { params } = this.props;
        if(params['investigationAreaId'])
        {
            this.loadDiseaseList(params['investigationAreaId'])
        }
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllInvestigationArea,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const areaOptions = (res.data || []).map(item => {
                const { investigationAreaId, investigationAreaName } = item;
                return {
                    label: investigationAreaName,
                    value: investigationAreaId,
                };
            });
            this.setState({ areaOptions });
        });
    }

    loadDiseaseList = (investigationAreaId) => {
        if (!investigationAreaId) return;
        const options = {
            method: 'POST',
            url: API_URL.common.queryAllDisease,
            data: { investigationAreaId },
            dataType: 'json',
            doneResult: res => {
                const diseaseOptions = (res.data || []).map(item => {
                    const { diseaseId, diseaseName } = item;
                    return {
                        value: diseaseId,
                        label: diseaseName,
                    };
                });
                this.setState({ diseaseOptions });
            }
        };
        $.sendRequest(options);
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    handleChange = (params, key) => {
        if (key === 'investigationAreaId') {
            params.diseaseId = undefined;
            this.props.onChange(params, key);
            this.loadDiseaseList(params['investigationAreaId']);
        } else if (key === 'lineOfBusiness') {
            params.secondLineName = undefined;
            this.props.onChange(params, key);
        } else {
            this.props.onChange(params, key);
        }
    }

    getOptions = (list) => {
        return (list || []).map(i => ({ label: i.optionValue, value: i.majorConfigureId }));
    }

    render() {
        const { config, onChange, ...rest } = this.props;
        const { areaOptions, diseaseOptions, businessList } = this.state;
        const { params } = rest;
        const { configure } = this.context;
        const { invState } = sessionStorage;
        const { lineOfBusiness } = params;
        const isCenter = invState == 1;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const secondLineOption = [...secondLineSet].map(i => ({ value: i, label: i }));
        const {
            REMITTANCE_POSSIBILITY = [],//可能行
        } = configure || {};
        (REMITTANCE_POSSIBILITY || []).forEach(i => { i.label= i.typeValue; i.value=  i.coTraceConfigureId; });
        const accountDistributeOption = accountDistributes.map(i => ({ value: i.accountDistribute, label: i.accountDistributeShow }));
        
        const filters = [{
            name: '项目简称',
            key: 'investigation',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'investigationName',
                style: {width: 160},
                placeholder: '输入名称检索',
                params: {limit: 20},
                url: API_URL.investigation.queryInvestigationByName,
                config: { id: 'investigationId', name: 'investigationName' }
            }
        },{
            name: 'JDE主项目号',
            key: 'jdeMainCode',
            type: 'input',
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }, {
            name: '执行业务线二级分类',
            key: 'secondLine',
            type: 'select',
            typeProperty: {
                style:{ width: 140 },
                disabled: !lineOfBusiness,
                list: secondLineOption,
            }
        }, {
            name: 'PM',
            key: 'pmUserId',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '项目领域',
            key: 'investigationAreaId',
            type: 'select',
            typeProperty: {
                list: areaOptions,
            }
        }, {
            name: '疾病',
            key: 'diseaseId',
            type: 'select',
            typeProperty: {
                list: diseaseOptions,
                disabled: !params['investigationAreaId'],
            }
        }, {
            name: 'PML（包含大区总监）',
            key: 'pmlUserId',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.investigation.queryUserByKey,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        },{
            name: '下月开票可能性判断',
            key: 'nextInvoicePossibilityId',
            type: 'select',
            typeProperty: {
                list: REMITTANCE_POSSIBILITY,
            }
        },{
            name:'账期分布',
            key:'accountDistribute',
            type:'select',
            typeProperty: {
                list: accountDistributeOption,
                style:{
                    width:'150px'
                }
            }
        }];
        return (
            <FilterBasic
                filters={filters}
                onChange={this.handleChange}
                {...rest}
            />
        )
    }
}

export default FundsFilter;


// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/components/FundsFilter.js